/**
 * Screens not yet built point here. It renders the route title, stage and a "coming soon"
 * note, so the full route map, menus and guards work from day one (spec §11 lists ~45 screens).
 * Swap the import for the real view when its ticket lands.
 */
export const placeholder = () => import('@/app/views/PlaceholderView.vue')
